import { atom } from 'jotai'
import { cartItemsAtom, cartOwnerIdAtom } from './cart.store'
import type { TTinyCustomer } from '@/core/types'

/**
 * CustomerData type for checkout form
 * This is a simplified type for form handling
 */
export type CustomerData = {
    id: string
    fullName: string
    email: string
    phone: string
}

// Editable customer info (for order-detail form)
export interface EditableCustomerInfo {
    fullName: string
    email: string
    phone: string
}

// Atoms
export const customerIdAtom = atom<string | null>(null)
export const customerDataAtom = atom<TTinyCustomer | null>(null)
export const isLoadingCustomerAtom = atom<boolean>(false)
export const customerErrorAtom = atom<string | null>(null)
export const seatingZoneAtom = atom<string>('')
export const editableCustomerAtom = atom<EditableCustomerInfo | null>(null)

// Derived: Check if customer is loaded
export const hasCustomerAtom = atom(get => {
    return get(customerDataAtom) !== null
})

// Action: Set customer data
export const setCustomerDataAtom = atom(null, (get, set, customer: TTinyCustomer) => {
    const currentOwnerId = get(cartOwnerIdAtom)
    const newCustomerId = customer.id?.unicity?.toString() || customer.unicity?.toString() || ''

    // If customer id changed, clear the cart
    if (currentOwnerId !== null && currentOwnerId !== newCustomerId) {
        set(cartItemsAtom, [])
    }

    // Update cart owner id
    set(cartOwnerIdAtom, newCustomerId)

    set(customerDataAtom, customer)
    set(customerIdAtom, newCustomerId)
    set(customerErrorAtom, null)
})

// Action: Clear customer
export const clearCustomerAtom = atom(null, (_get, set) => {
    set(customerDataAtom, null)
    set(customerIdAtom, null)
    set(customerErrorAtom, null)
    set(editableCustomerAtom, null)
    set(cartItemsAtom, [])
    set(cartOwnerIdAtom, null)
})
